/** Client admin permission string constants. */
export const ClientPermissions = {
  identityManage: 'client_identity_manage',
  identityAccess: ['client_identity_manage'] as const,
  contractsRead: 'clients_contracts_read',
  contractsDocumentsRead: 'clients_contracts_documents_read',
  contractsManage: 'clients_contracts_manage',
  contractProfitRead: 'clients_contract_profit_read',
  contractProfitManage: 'clients_contract_profit_manage',
  contractsAccess: [
    'clients_contracts_read',
    'clients_contracts_manage',
  ] as const,
  invoicesManage: 'client_invoices_manage',
  invoicesApprove: 'client_invoices_approve',
  invoicesSend: 'client_invoices_send',
  invoicesAccess: [
    'client_invoices_manage',
    'client_invoices_approve',
    'client_invoices_send',
  ] as const,
} as const
